import { useEffect } from "react";
import useTimerData from "store/TimerStore";
import useUrlData from "store/DataStore";
import TimerSVG from "svg/icons/TimerSVG";
import styles from "./timer.module.scss";

const TimerComponent = () => {
  const { minutes, seconds, setExpiresAt, syncServerTime, decreaseTimer, setTimer } = useTimerData();
  const { expiresAt, expires_in } = useUrlData((state) => state.data);

  useEffect(() => {
    // Sync with server time first
    syncServerTime();
  }, [syncServerTime]);

  useEffect(() => {
    // Use expiresAt from server if available
    if (expiresAt) {
      setExpiresAt(expiresAt);
    } else if (expires_in > 0) {
      // Fallback to expires_in (seconds)
      setTimer(expires_in);
    }
  }, [expiresAt, expires_in, setExpiresAt, setTimer]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      decreaseTimer();
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [decreaseTimer]);

  return (
    <div className={styles.timer}>
      <TimerSVG width="24" height="24" />
      <span style={{ width: '50px', height: '100%', textAlign: 'center' }}>
        {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </span>
    </div>
  );
};

export default TimerComponent;